import axios from "axios";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../Config";
import UploadWidget from "./Components/UploadWidget";

const Positions = (props) => {
  const [UploadCount, setUploadCount] = useState(0);
  const [UploadInProgress, setUploadInProgress] = useState(false);
  const [PosErr, setPosErr] = useState(false);
  const [JobReqErr, setJobReErr] = useState(false);
  const [PosSalaryErr, setPosSalaryErr] = useState(false);
  const [PosAssignErr, setPosAssignErr] = useState(false);
  const [PosRelErr, setPosRelErr] = useState(false);
  const [FirstDialogIsOpen, setFirstDialogIsOpen] = useState(false);
  const [GenerateDescFor, setGenerateDescFor] = useState(null); //"ALL" | "WITHOUT_DESCRIPTION_ONLY" | null (no skill generation)
  const [SecondDialogIsOpen, setSecondDialogIsOpen] = useState(false);

  var CheckFileCountTimer;

  useEffect(() => {
    CheckFileCountTimer = setInterval(updatePrevFileCount, 100);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateFileSize = (FileSize, Id) => {
    setTimeout(() => {
      if (FileSize <= 1) {
        document.getElementById(Id).innerHTML = translateText(
          "data_import_widget_error_non_empty"
        );
      }
    }, 100);
  };

  const updatePrevFileCount = () => {
    var Count = 0;
    for (let i = 1; i < 6; i++) {
      if (
        document.getElementById("csv-" + i + "-check") !== null &&
        document
          .getElementById("csv-" + i + "-check")
          .classList.contains("feather-check")
      ) {
        Count++;
      }
    }
    setUploadCount(Count);
  };

  const handleCheckboxChange = (Id, GenerateSkillValue) => {
    let IsChecked = document.getElementById(Id).checked;

    if (IsChecked) {
      setGenerateDescFor(GenerateSkillValue);
      props.SetGenerateJobDescFor(GenerateSkillValue);
    } else {
      setGenerateDescFor(null);
      props.SetGenerateJobDescFor(null);
    }
  };

  const updateMandatoriesStatus = () => {
    props.CheckPosFilesUpload();
  };

  // this function is called after each file is uploaded inside the then promise, to
  // check the uploaded file extension and in case it is wrong (non-csv) it will set an
  // innerHTML for the error <p></p> tag with the relevant Id. FileName and ErrorElementId
  // are passed down as params to the function call and are different for each upload widget and
  // each uploaded file.
  const validateUploadedFileExtension = (FileName, ErrorElementId) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(ErrorElementId) !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(ErrorElementId).innerHTML =
          "Please upload a csv file.";
      }
    }
  };

  const handleUploadEnd = () => {
    updatePrevFileCount();
  };

  // Position.csv file upload handler
  const uploadPositionCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-1-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/position/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-1-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setPosErr(false);
        } else {
          setPosErr(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-1-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setPosErr(true);
        handleUploadEnd();
      });
  };

  // JobRequirements.csv file upload handler
  const uploadJobRequirementsCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-2-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/job-requirement/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-2-error");
        handleUploadEnd();
        if (Res.status === 200) {
          if (Res.data.status === "SUCCESS") {
            setJobReErr(false);
          } else {
            setJobReErr(true);
          }
        } else {
          setJobReErr(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-2-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setJobReErr(true);
        handleUploadEnd();
      });
  };

  // PositionSalary.csv file upload handler
  const uploadPositionSalaryCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-3-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/position-salary/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-3-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setPosSalaryErr(false);
        } else {
          setPosSalaryErr(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-3-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setPosSalaryErr(true);
        handleUploadEnd();
      });
  };

  // PosAssignment.csv file upload handler
  const uploadPosAssignmentCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-4-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/position-assignment/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-4-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setPosAssignErr(false);
        } else {
          setPosAssignErr(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-4-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setPosAssignErr(true);
        handleUploadEnd();
      });
  };

  // PosRelation.csv file upload handler
  const uploadPosRelationCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-5-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/position-relation/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-5-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setPosRelErr(false);
        } else {
          setPosRelErr(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-5-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setPosRelErr(true);
        handleUploadEnd();
      });
  };

  return (
    <div className="simple-form">
      <section className="form-head">
        <h1>
          {translateText("position_files")} <p>*</p>
        </h1>
      </section>
      <div className="form-body">
        <p className="info-top">
          {UploadCount +
            " " +
            translateText("of") +
            " " +
            "5 " +
            translateText("files_uploaded_successfully")}
        </p>
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadPositionCSV()}
          Enum={"POSITION"}
          API_Name={"position"}
          UploadHadErrors={PosErr}
          SwitchErrorState={() => setPosErr(!PosErr)}
          Placeholder="Position.csv"
          Id="csv-1"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setPosErr(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadJobRequirementsCSV()}
          Enum={"JOB_REQUIREMENT"}
          API_Name={"job-requirement"}
          UploadHadErrors={JobReqErr}
          SwitchErrorState={() => setJobReErr(!JobReqErr)}
          Placeholder="JobRequirements.csv"
          Id="csv-2"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setJobReErr(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadPositionSalaryCSV()}
          Enum={"POSITION_SALARY"}
          API_Name={"position-salary"}
          UploadHadErrors={PosSalaryErr}
          SwitchErrorState={() => setPosSalaryErr(!PosSalaryErr)}
          Placeholder="PositionSalary.csv"
          Id="csv-3"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setPosSalaryErr(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadPosAssignmentCSV()}
          Enum={"POSITION_ASSIGNMENT"}
          API_Name={"position-assignment"}
          UploadHadErrors={PosAssignErr}
          SwitchErrorState={() => setPosAssignErr(!PosAssignErr)}
          Placeholder="PosAssignment.csv"
          Id="csv-4"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setPosAssignErr(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadPosRelationCSV()}
          Enum={"POSITION_RELATION"}
          API_Name={"position-relation"}
          UploadHadErrors={PosRelErr}
          SwitchErrorState={() => setPosRelErr(!PosRelErr)}
          Placeholder="PosRelation.csv"
          Id="csv-5"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setPosRelErr(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <section className="checkbox-row">
          <p className="row-text">
            {translateText("generate_description_for_jobs")}
          </p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setFirstDialogIsOpen(true)}
              onMouseLeave={() => setFirstDialogIsOpen(false)}
            ></i>
            {FirstDialogIsOpen ? (
              <section className="info-popup">
                {translateText("generate_description_for_jobs_info")}
              </section>
            ) : null}
            <label
              className={
                GenerateDescFor === "WITHOUT_DESCRIPTION_ONLY" ||
                GenerateDescFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() =>
                  handleCheckboxChange(
                    "checkbox-jpa",
                    "WITHOUT_DESCRIPTION_ONLY"
                  )
                }
                type="checkbox"
                id="checkbox-jpa"
                class="blue-checkbox"
                checked={
                  props.GenerateJobDescFor === "WITHOUT_DESCRIPTION_ONLY"
                    ? true
                    : false
                }
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
        <section className="checkbox-row">
          <p className="row-text">
            {translateText("generate_description_for_all_jobs")}
          </p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setSecondDialogIsOpen(true)}
              onMouseLeave={() => setSecondDialogIsOpen(false)}
            ></i>
            {SecondDialogIsOpen ? (
              <section className="info-popup">
                {translateText("generate_description_for_all_jobs_info")}
              </section>
            ) : null}
            <label
              className={
                GenerateDescFor === "ALL" || GenerateDescFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() => handleCheckboxChange("checkbox-all", "ALL")}
                type="checkbox"
                id="checkbox-all"
                class="blue-checkbox"
                checked={props.GenerateJobDescFor === "ALL" ? true : false}
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
      </div>
    </div>
  );
};
export default Positions;
